import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import Select, { SingleValue } from "react-select";
import { FieldErrors } from '../domain/helpers/Errors';
import { useDarkModeStore } from '../store/useDarkModeStore';
import { useLanguageStore } from '../store/useLanguageStore';
import { CACHE_KEY_USERS_BYFIRSTLASTNAME, darkModeBackgroud, darkModeBackgroudInputs } from '../utils/constants';
import ToastMessage from './ToastMessage';
import FormControl from '@mui/material/FormControl';
import useUserByFirstLastname from '../store/ReactQueries/users/useUserByFirstLastname';

interface SelectUserProps<T extends { [key: string]: any }> {
    form: T;
    view: boolean;
    column: GridColDef;
    errors: FieldErrors;
    setForm: React.Dispatch<React.SetStateAction<T>>;
}

export const SelectUser = <T extends { [key: string]: any }>({ column, form, errors, view = false, setForm }: SelectUserProps<T>) => {

    const name = column.field;
    const nameId = `${column.field}Id`
    const fieldError = errors?.[name as keyof FieldErrors] ?? errors?.[nameId as keyof FieldErrors];

    const [userTitle, setUserTitle] = useState<string>(form?.[name] ? form[name]?.firstname : '');
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { data: users, error: usersError } = useUserByFirstLastname(CACHE_KEY_USERS_BYFIRSTLASTNAME, 1, 20, userTitle);

    const handleSelect = (
        selectedOption: SingleValue<{
            label: any;
            value: string;
        }>
    ) => {
        delete errors?.[name];
        delete errors?.[nameId];
        if (!selectedOption) {
            setForm({
                ...form,
                [name + 'Id']: "",
                [name]: { firstname: "", lastname: "" },
            });
            return;
        }

        const fullName = selectedOption.label;
        const [firstname, lastname] = fullName.split(" ");

        setForm({
            ...form,
            [name + 'Id']: selectedOption.value,
            [name]: { firstname, lastname },
        });
    };

    useEffect(() => {
        if (usersError) ToastMessage.Failed(usersError.message);
    }, [usersError]);

    return <FormControl fullWidth className='mt-2 mb-2' >
        <label style={darkMode ? { background: darkModeBackgroud, color: 'white' } : {}}>{language[name.charAt(0).toUpperCase() + name.slice(1)]}</label>
        <Select
            value={{
                label: `${form?.[name]?.firstname ?? ""} ${form?.[name]?.lastname ?? ""}`,
                value: form?.[name] || "",
            }}
            className={`${darkMode && "dark-mode-input"} position-relative`}
            onChange={handleSelect}
            onInputChange={(inputValue) => setUserTitle(inputValue)}
            placeholder="Zgjedh"
            options={users?.map(({ id, firstname, lastname }) => ({
                value: id ?? "",
                label: `${firstname ?? ""} ${lastname ?? ""}`,
            }))}
            isClearable
            isDisabled={view}
            styles={{
                menu: (provided) => ({
                    ...provided,
                    zIndex: 11,
                    color: darkMode ? 'white' : 'initial',
                    minHeight: 52
                }),
                container: (provided) => ({
                    ...provided,
                    position: "relative",
                    zIndex: 11,
                    color: darkMode ? 'white' : 'initial',
                    minHeight: 52
                }),
                singleValue: (provided) => ({
                    ...provided,
                    color: darkMode ? 'white' : 'black',
                    padding: '13px 0px',
                    minHeight: 52
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                }),
                control: (provided) => ({
                    ...provided,
                    minHeight: 52,
                    backgroundColor: darkMode ? darkModeBackgroudInputs : "#F3F6F9",
                    borderColor: darkMode ? darkModeBackgroudInputs : "initial",
                    background: darkMode ? darkModeBackgroud : 'white'
                }),
            }}
            menuPlacement="bottom"
            menuPortalTarget={document.body}
        />
        {
            fieldError
            && <p
                className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1wc848c-MuiFormHelperText-root"
                style={{ color: 'red', marginTop: '0.5rem' }}
            >
                {fieldError}
            </p>
        }
    </FormControl>
}
export default SelectUser